import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Parameters, Row, Col, Button, Icon } from "@perxis-auto/ui-kit";
import { withEnabledComponent } from "../../../shared/lib/constructor/withEnabledComponent.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import { selectFilters } from "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeo.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import { Constructor } from "../../../shared/ui/constructor/Constructor.js";
import { Wrapper } from "./wrapper/Wrapper.js";
import styles from "./FilterPanel.module.scss.js";
const FilterPanel = withEnabledComponent(
  memo(function FilterPanel2({
    widgets,
    asideRef,
    asideHeight,
    isMobile,
    isVisible,
    isLoading,
    hasFooter,
    activeGroups,
    items,
    t,
    onToggle,
    onReset,
    onGroupsChange
  }) {
    return /* @__PURE__ */ jsx(
      Wrapper,
      {
        title: t("widgets.filterPanel.title"),
        isMobile,
        isVisible,
        onToggle,
        asideRef,
        asideHeight,
        className: styles.filterPanel,
        children: !!items && /* @__PURE__ */ jsx(
          Parameters,
          {
            activeGroups,
            groups: items,
            isLoading,
            onChange: onGroupsChange,
            className: styles.filterPanel__parameters,
            footer: hasFooter ? /* @__PURE__ */ jsxs(Row, { gutter: [18, "vertical-sky"], children: [
              isMobile && /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(
                Button,
                {
                  type: "primary",
                  icon: /* @__PURE__ */ jsx(Icon, { name: "forward", sticker: "filter-panel-apply-icon" }),
                  onClick: onToggle,
                  children: t("widgets.filterPanel.applyLabel")
                }
              ) }),
              /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(
                Button,
                {
                  type: "ghost",
                  icon: /* @__PURE__ */ jsx(Icon, { name: "cross", sticker: "filter-panel-reset-icon" }),
                  onClick: onReset,
                  children: t("widgets.filterPanel.resetLabel")
                }
              ) })
            ] }) : null,
            children: (group) => {
              return /* @__PURE__ */ jsx(Constructor, { isSubConstructor: true, layout: group, widgets });
            }
          }
        )
      }
    );
  }),
  selectFilters
);
export {
  FilterPanel
};
